<template>
  <div class="flex flex-col justify-center gap-xs bg-secondary-40 rounded-xl p-l text-white">
    <div class="flex flex-col items-center text-center gap-xs">
      <Icon
        name="iad-icon:propertips"
        class="size-24"
        title="Logo Propertips"
      />
      <IadTitle
        tag="p"
        class="text-balance"
        :text="$t('property_serp.promo.propertips.title')"
      />
      <IadTitle
        tag="span"
        variant="x-small"
        class="text-pretty"
        :text="$t('property_serp.promo.propertips.subtitle')"
      />
      <IadBtn
        href="https://form.iadfrance.fr/prescription/"
        target="_blank"
        :text="$t('property_serp.promo.propertips.cta')"
      />
    </div>
    <span
      class="text-xs text-left"
    >*{{ $t('property_serp.promo.propertips.hint') }}&nbsp;<a
      href="https://www.propertips.com"
      target="_blank"
      class="underline"
    >propertips.com</a></span>
  </div>
</template>
